import React, { useState } from 'react'
import styled from '@emotion/styled'
import AddressAutocomplete from './AddressAutocomplete'
import Modal from './Modal'
import { Header3, Text } from '../../../../styles/Components'
import { mq } from '../../../../helpers'
import ArrowButton from '../../../ArrowButton'

const AddressDiv = styled.div`
  padding: 0 30px 30px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mq('max', '768px')} {
    padding: 0 16px 30px;

    h3 {
      font-size: 28px !important;
    }

    p {
      font-size: 16px !important;
    }
  }

  div {
    ${mq('max', '768px')} {
      width: 100%;
    }
  }

  button {
    ${mq('max', '768px')} {
      width: 100%;
    }
  }
`

const AddressModal = ({
  currentMarket,
  onSubmit,
  initialValue,
  isOpen,
  close,
  isDesktop,
}) => {
  const [address, setAddress] = useState()
  const [market, setMarket] = useState()

  const dispatch = ({ market, address }) => {
    setMarket(market)
    setAddress(address)
  }

  return (
    <Modal
      isOpen={isOpen}
      closeModal={close}
      width="700px"
      isDesktop={isDesktop}
    >
      <AddressDiv>
        <Header3
          fontSize={28}
          lineHeight="140%"
          align="center"
          margin="0 0 16px"
        >
          Where do you want to book?
        </Header3>
        <Text lineHeight="140%" margin="0 0 35px">
          Enter your address below - you&apos;ll select a date & time next.
        </Text>
        <AddressAutocomplete
          currentMarket={currentMarket}
          hasSelectedServices={true}
          dispatch={dispatch}
          initialValue={initialValue}
        />
        <ArrowButton
          margin="60px 0 0"
          disabled={!address}
          onClick={() => onSubmit(market, address)}
        >
          Continue
        </ArrowButton>
      </AddressDiv>
    </Modal>
  )
}

export default AddressModal
